import * as React from "react";
import * as ReactCSSTransitionReplace from "react-css-transition-replace";
import { isIE } from "react-device-detect";
import { Colors, IFooterButton } from "src/ScrollyInterface";
import { getTextStyle } from "src/shared/getTextStyle";
import "./FooterButton.scss";

import Scroll_ico_black from "../../assets/Icons/Black/Scroll_ico.svg";
import Scroll_ico_white from "../../assets/Icons/White/Scroll_ico.svg";

const footerButton = (props: IFooterButton) => {
  const {
    bounce,
    styles,
    contentId,
    elemNumber,
    footer,
    onScrollClicked
  } = props;
  const footerText = footer && footer.text ? footer.text : "";
  const scrollIco = footer ? (footer.color === Colors.black ? Scroll_ico_black : Scroll_ico_white) : Scroll_ico_white;
  const handleScrollClicked = () => {
    onScrollClicked();
  };

  const getBounce = () => {
    return bounce ? "bounce" : "";
  };

  const getScrollButton = () => {
    const styleIE = isIE
      ? {
          opacity: props.videoLoaded ? 1 : 0,
          transition: "opacity 0.3s ease-in"
        }
      : {};
    return contentId === elemNumber - 1 ? null : (
      <div
        style={styleIE}
        className="FooterButton-scrollLink"
        key={`link-${contentId}`}
        onClick={handleScrollClicked}
      >
        <img src={scrollIco} />
        <span
          className="FooterButton-text"
          style={{ ...getTextStyle(footer), ...styles }}
        >
          {footerText}
        </span>
      </div>
    );
  };

  const scrollButton = isIE ? (
    getScrollButton()
  ) : (
    <ReactCSSTransitionReplace
      transitionName="fade-wait"
      transitionEnterTimeout={1800}
      transitionLeaveTimeout={800}
    >
      {getScrollButton()}
    </ReactCSSTransitionReplace>
  );

  return (
    <div className={getBounce()} style={{ width: "100%" }}>
      {scrollButton}
    </div>
  );
};

export default footerButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/FooterButton.tsx